import ResourceManager from "@/components/common/ResourceManager";
import { eur, fdate, km } from "@/lib/format";

const vehLabel = (id, lookups) => {
  const v = (lookups.vehicles || []).find((x) => x.id === id);
  return v ? `${v.brand} ${v.model} (${v.registration})` : "—";
};

export default function Maintenance() {
  const columns = [
    { key: "vehicle_id", label: "Véhicule", render: (r, l) => vehLabel(r.vehicle_id, l) },
    { key: "date", label: "Date", render: (r) => fdate(r.date) },
    { key: "type", label: "Type" },
    { key: "garage", label: "Garage" },
    { key: "mileage", label: "Km", render: (r) => km(r.mileage) },
    { key: "cost_ttc", label: "Coût TTC", render: (r) => eur(r.cost_ttc) },
    { key: "next_date", label: "Prochaine", render: (r) => fdate(r.next_date) },
  ];
  const fields = [
    { key: "vehicle_id", label: "Véhicule", type: "vehicle", full: true },
    { key: "date", label: "Date", type: "date" },
    { key: "type", label: "Type", type: "select", options: ["Révision", "Vidange", "Freins", "Pneus", "Batterie", "Climatisation", "Distribution", "Réparation", "Carrosserie", "Autre"] },
    { key: "garage", label: "Garage" },
    { key: "mileage", label: "Kilométrage", type: "number" },
    { key: "cost_ht", label: "Coût HT (€)", type: "number" },
    { key: "vat", label: "TVA (€)", type: "number" },
    { key: "cost_ttc", label: "Coût TTC (€)", type: "number" },
    { key: "next_date", label: "Prochaine échéance", type: "date" },
    { key: "description", label: "Description", type: "textarea", full: true },
  ];
  return <ResourceManager title="Entretiens" subtitle="Maintenance, réparations et interventions." resource="maintenance" exportCollection="maintenance" columns={columns} fields={fields} lookupsNeeded={["vehicles"]} defaultForm={{ type: "Révision" }} />;
}
